module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/headquarters/hq-grid-1-large-b88583ce610369e62d79315fd904406d.jpg";